<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="navigation-bg" />
    <simplebar id="scroll">
      <ul id="side-menu" side-navigation class="nav">
        <li class="nav-header">
          <div class="header-content text-center">
            <img :src="LogoSource" alt class="sidebar-logo" />
            <strong>{{ Nome }}</strong>
            <br />
            <span>{{ Instituicao }}</span>
          </div>
        </li>
        <li v-if="ExibeDashboard">
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-line-chart fa-fw" />
            <span id="dashboard-menu" class="nav-label">
              {{ $t('dashboard') }}
            </span>
          </router-link>
        </li>
        <li v-if="ExibeLancamento">
          <router-link :to="{ name: 'lancamento-index' }">
            <i class="fa fa-bars fa-fw" />
            <span id="lancamento-menu" class="nav-label">
              {{ $t('exclusive_files') }}
            </span>
          </router-link>
        </li>
        <li v-if="ExibeDashboardDinamico">
          <router-link :to="{ name: 'dashboard-dinamico-index' }">
            <i class="fa fa-line-chart fa-fw" />
            <span id="dashboard-menu" class="nav-label">
              {{ $t('dynamic_dashboards') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'serie-index' }">
            <i class="fa fa-history fa-fw" />
            <span id="serie-menu" class="nav-label">
              {{ $t('historic_serie') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'mercado-index' }">
            <i class="fa fa-bar-chart fa-fw" />
            <span id="mercado-menu" class="nav-label">
              {{ $t('market_reports') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'customizado-index' }">
            <i class="fa fa-pencil-square-o fa-fw" />
            <span id="customizado-menu" class="nav-label">
              {{ $t('customs') }}
            </span>
          </router-link>
        </li>
      </ul>
    </simplebar>
  </nav>
</template>

<script>
import { getUserData } from '../lib/token'
import { mapGetters } from 'vuex'
import $ from 'jquery'
import 'metismenu'
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'
import LogoProduction from '../assets/images/imea-logo.svg'
import LogoHomolog from '../assets/images/imea-logo-homolog.svg'
import LogoDevelopment from '../assets/images/imea-logo-development.svg'

export default {
  name: 'Navigation',
  components: {
    simplebar
  },
  computed: {
    LogoSource() {
      switch (process.env.VUE_APP_MODE) {
        case 'production':
          return LogoProduction
        case 'homolog':
          return LogoHomolog
        default:
          return LogoDevelopment
      }
    },
    Instituicao() {
      const data = window.localStorage.getItem('imea.portal.instituicao')
      if (data) {
        const obj = JSON.parse(data)
        return obj ? obj.Nome : ''
      }

      return undefined
    },
    Nome() {
      let nome = ''
      const data = getUserData()
      if (data) {
        nome = data.Nome
      }
      return nome
    },
    ExibeDashboard() {
      const data = window.localStorage.getItem('imea.portal.userinfo')
      if (data) {
        const obj = JSON.parse(data)
        return obj ? obj.ExibeDashboard : ''
      }
      return undefined
    },
    ExibeLancamento() {
      const data = window.localStorage.getItem('imea.portal.userinfo')
      if (data) {
        const obj = JSON.parse(data)
        return obj ? obj.ExibeLancamento : ''
      }
      return undefined
    },
    ExibeDashboardDinamico() {
      const data = window.localStorage.getItem('imea.portal.userinfo')
      if (data) {
        const obj = JSON.parse(data)
        return obj ? obj.ExibeDashboardDinamico : ''
      }
      return undefined
    },

    ...mapGetters('menu', ['menuData'])
  },
  mounted() {
    $('#side-menu').metisMenu()
  },
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0
      })
    }
  }
}
</script>
